
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftRight25 as ObiThreewayStackedInleftRight25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-right-25.js';
 
 
 

 
 export const ObiThreewayStackedInleftRight25 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-right-25',
   elementClass: ObiThreewayStackedInleftRight25Element,
   events: {
     
   }
  });
 
 